import { debounce, roundToDecimals } from '@sg-core/resources/assets/js/utils';

export interface DelayerOptions {
  index?: number;
  animateByRow?: boolean;
  delay?: number;
  initialDelay?: number;
  elements?: NodeListOf<Element>;
}

export class Delayer {
  private elem: HTMLElement;
  private index: number;
  private animateByRow: boolean;
  private delay: number;
  private initialDelay: number;
  private elements: NodeListOf<Element>;
  private handleResize: (...args: unknown[]) => void;

  constructor(elem: HTMLElement, options: DelayerOptions = {}) {
    this.elem = elem;
    this.index = options.index ?? 0;
    this.animateByRow = options.animateByRow ?? false;
    this.delay = options.delay ?? 0;
    this.initialDelay = options.initialDelay ?? 0;
    this.elements = options.elements ?? (new NodeList() as NodeListOf<Element>);

    this.init();

    this.handleResize = debounce(() => this.init(), 250);

    window.addEventListener('resize', this.handleResize);
  }

  private init(): void {
    if (this.animateByRow) {
      this.setAnimateByRowDelay();
    } else {
      this.setDelay();
    }
  }

  private setDelay(): void {
    this.elem.style.setProperty('--delay-dynamic', `${roundToDecimals(this.initialDelay + this.index * this.delay)}s`);
  }

  private setAnimateByRowDelay(): void {
    if (this.index === 0) {
      this.elem.setAttribute('data-dynamic-delay', String(this.initialDelay));
      this.elem.style.setProperty('--delay-dynamic', `${roundToDecimals(this.initialDelay)}s`);
      return;
    }

    const indexPreviousElement = this.index - 1;
    const previousElement = this.elements[indexPreviousElement];

    const rect = this.elem.getBoundingClientRect();
    const rectPrevious = previousElement.getBoundingClientRect();

    if (rect.top === rectPrevious.top) {
      const previousDelay = previousElement.getAttribute('data-dynamic-delay');

      const delay = Number(previousDelay) + this.delay;

      this.elem.setAttribute('data-dynamic-delay', String(delay));

      this.elem.style.setProperty('--delay-dynamic', `${roundToDecimals(delay)}s`);
    } else {
      this.elem.setAttribute('data-dynamic-delay', String(this.initialDelay));
      this.elem.style.setProperty('--delay-dynamic', `${roundToDecimals(this.initialDelay)}s`);
    }
  }
}
